import { TOKEN } from '../enums/ENUMS';
import { SortOptions, SortType } from '../enums/SORT';

export const ACCESS_TOKEN_UPDATED_EVENT = 'amplify:access-token-updated';

export const removeToken = (): void => {
  const hadToken = Boolean(localStorage.getItem(TOKEN.ACCESS_TOKEN));
  localStorage.removeItem(TOKEN.ACCESS_TOKEN);
  if (typeof window !== 'undefined' && hadToken) {
    window.dispatchEvent(
      new CustomEvent(ACCESS_TOKEN_UPDATED_EVENT, {
        detail: { hasToken: false },
      }),
    );
  }
};

export const removeRefreshToken = (): void => {
  localStorage.removeItem(TOKEN.REFRESH_TOKEN);
};

export const setTokenLocalStorage = (token: string): void => {
  const previousToken = localStorage.getItem(TOKEN.ACCESS_TOKEN);
  localStorage.setItem(TOKEN.ACCESS_TOKEN, token);
  if (typeof window !== 'undefined' && previousToken !== token) {
    window.dispatchEvent(
      new CustomEvent(ACCESS_TOKEN_UPDATED_EVENT, {
        detail: { hasToken: Boolean(token) },
      }),
    );
  }
};

export const setRefreshTokenLocalStorage = (refreshToken: string): void => {
  localStorage.setItem(TOKEN.REFRESH_TOKEN, refreshToken);
};

export const setPreviewAccessToken = (token: string) => {
  return localStorage.setItem('previewAccessToken', `${token}`);
};
export const getPreviewAccessToken = () => {
  return localStorage.getItem('previewAccessToken');
};
export const removePreviewAccessToken = () => {
  return localStorage.removeItem('previewAccessToken');
};

export const setFinishPreviewUserId = (userId: number) => {
  return localStorage.setItem('finishPreviewUserId', `${userId}`);
};
export const getFinishPreviewUserId = () => {
  return localStorage.getItem('finishPreviewUserId');
};
export const removeFinishPreviewUserId = () => {
  return localStorage.removeItem('finishPreviewUserId');
};

export const getTokenFromLocalStorage = () => {
  return localStorage.getItem(TOKEN.ACCESS_TOKEN);
};

export const getRefreshFromTokenLocalStorage = () => {
  return localStorage.getItem(TOKEN.REFRESH_TOKEN);
};

export const setTooltipShown = () => {
  return localStorage.setItem('showedTooltip', 'true');
};

export const removeTooltipShown = () => {
  return localStorage.removeItem('showedTooltip');
};

export const getTooltipShown = () => {
  const value = localStorage.getItem('showedTooltip');
  return value;
};

export const setMyFoldersSortOptionAndType = (sort: SortType, sortOptions: SortOptions) => {
  let sortState = JSON.parse(getSortStateForMyFolders()!);
  if (sortState) {
    sortState = {
      ...sortState,
      [sortOptions]: sort,
    };
  } else {
    sortState = {
      [sortOptions]: sort,
    };
  }
  setSortStateForMyFolders(sortState);
  return localStorage.setItem('MyFoldersSortType', `${sort}/${sortOptions}`);
};
const setSortStateForMyFolders = (json: any) => {
  localStorage.setItem('MyFoldersSortState', JSON.stringify(json));
};
export const getSortStateForMyFolders = () => {
  return localStorage.getItem('MyFoldersSortState');
};

export const setAllContentSortOptionAndType = (sort: SortType, sortOptions: SortOptions) => {
  let sortState = JSON.parse(getSortStateForAllContent()!);
  if (sortState) {
    sortState = {
      ...sortState,
      [sortOptions]: sort,
    };
  } else {
    sortState = {
      [sortOptions]: sort,
    };
  }
  setSortStateForAllContent(sortState);
  return localStorage.setItem('AllContentSortType', `${sort}/${sortOptions}`);
};
const setSortStateForAllContent = (json: any) => {
  localStorage.setItem('AllContentSortState', JSON.stringify(json));
};
export const getSortStateForAllContent = () => {
  return localStorage.getItem('AllContentSortState');
};

export const getAllContentSortOptionAndType = () => {
  return localStorage.getItem('AllContentSortType');
};

export const getMailChecker = () => {
  return localStorage.getItem('MailChecker');
};

export const setMailChecker = (value: boolean) => {
  localStorage.setItem('MailChecker', JSON.stringify(value));
};

export const deleteMailChecker = () => {
  localStorage.removeItem('MailChecker');
};

// Getter for MyFoldersSortType
export const getMyFoldersSortOptionAndType = () => {
  return localStorage.getItem('MyFoldersSortType');
};

export const setParentFoldersSortOptionAndType = (sort: SortType, sortOptions: SortOptions) => {
  let sortState = JSON.parse(getSortStateForParentFolders()!);
  if (sortState) {
    sortState = {
      ...sortState,
      [sortOptions]: sort,
    };
  } else {
    sortState = {
      [sortOptions]: sort,
    };
  }
  setSortStateForParentFolders(sortState);
  return localStorage.setItem('ParentFoldersSortType', `${sort}/${sortOptions}`);
};
const setSortStateForParentFolders = (json: any) => {
  localStorage.setItem('ParentFoldersSortState', JSON.stringify(json));
};
export const getSortStateForParentFolders = () => {
  return localStorage.getItem('ParentFoldersSortState');
};
export const getParentFoldersSortOptionAndType = () => {
  return localStorage.getItem('ParentFoldersSortType');
};

export const setMyVideofeedsSortOptionAndType = (sort: SortType, sortOptions: any) => {
  let sortState = JSON.parse(getSortStateForMyVideoFeeds()!);
  if (sortState) {
    sortState = {
      ...sortState,
      [sortOptions]: sort,
    };
  } else {
    sortState = {
      [sortOptions]: sort,
    };
  }
  setSortStateForMyVideoFeeds(sortState);
  return localStorage.setItem('MyVideofeedsSortType', `${sort}/${sortOptions}`);
};
// Getter for MyVideofeedsSortType
export const getMyVideofeedsSortOptionAndType = () => {
  return localStorage.getItem('MyVideofeedsSortType');
};
const setSortStateForMyVideoFeeds = (json: any) => {
  localStorage.setItem('MyVideofeedsSortState', JSON.stringify(json));
};
export const getSortStateForMyVideoFeeds = () => {
  return localStorage.getItem('MyVideofeedsSortState');
};

export const setSharedWithMePageSortOptionAndType = (sort: SortType, sortOptions: SortOptions) => {
  let sortState = JSON.parse(getSortStateForSharedWithMe()!);
  if (sortState) {
    sortState = {
      ...sortState,
      [sortOptions]: sort,
    };
  } else {
    sortState = {
      [sortOptions]: sort,
    };
  }
  setSortStateForSharedWithMe(sortState);
  return localStorage.setItem('SharedWithMePageSortType', `${sort}/${sortOptions}`);
};
// Getter for SharedWithMePageSortType
export const getSharedWithMePageSortOptionAndType = () => {
  return localStorage.getItem('SharedWithMePageSortType');
};
const setSortStateForSharedWithMe = (json: any) => {
  localStorage.setItem('SharedWithMePageSortState', JSON.stringify(json));
};
export const getSortStateForSharedWithMe = () => {
  return localStorage.getItem('SharedWithMePageSortState');
};

export const setMyAmplifyComposersPageSortOptionAndType = (sort: SortType, sortOptions: SortOptions) => {
  let sortState = JSON.parse(getSortStateForAmplifyComposers()!);
  if (sortState) {
    sortState = {
      ...sortState,
      [sortOptions]: sort,
    };
  } else {
    sortState = {
      [sortOptions]: sort,
    };
  }
  setSortStateForAmplifyComposers(sortState);
  return localStorage.setItem('MyAmplifyComposersPageSortType', `${sort}/${sortOptions}`);
};
// Getter for MyAmplifyComposersPageSortType
export const getMyAmplifyComposersPageSortOptionAndType = () => {
  return localStorage.getItem('MyAmplifyComposersPageSortType');
};
const setSortStateForAmplifyComposers = (json: any) => {
  localStorage.setItem('MyAmplifyComposersPageSortState', JSON.stringify(json));
};
export const getSortStateForAmplifyComposers = () => {
  return localStorage.getItem('MyAmplifyComposersPageSortState');
};

export const setAllGroupsPageSortOptionAndType = (sort: SortType, sortOptions: SortOptions | string) => {
  return localStorage.setItem('getAllGroupsPageSortType', `${sort}/${sortOptions}`);
};
export const getAllGroupsPageSortOptionAndType = () => {
  return localStorage.getItem('getAllGroupsPageSortType');
};

export const setSubgroupsPageSortOptionAndType = (sort: SortType, sortOptions: string) => {
  return localStorage.setItem('getSubgroupsPageSortType', `${sort}/${sortOptions}`);
};
export const getSubgroupsPageSortOptionAndType = () => {
  return localStorage.getItem('getSubgroupsPageSortType');
};

export const setUserListPagePaginationLimit = (num: number) => {
  return localStorage.setItem('UserListPagePaginationLimit', `${num}`);
};
export const getUserListPagePaginationLimit = () => {
  return localStorage.getItem('UserListPagePaginationLimit');
};

export const setMyFoldersPagePaginationLimit = (num: number) => {
  return localStorage.setItem('MyFoldersPagePaginationLimit', `${num}`);
};
export const getMyFoldersPagePaginationLimit = () => {
  return localStorage.getItem('MyFoldersPagePaginationLimit');
};

export const setAllContentPagePaginationLimit = (num: number) => {
  return localStorage.setItem('AllContentPagePaginationLimit', `${num}`);
};
export const getAllContentPagePaginationLimit = () => {
  return localStorage.getItem('AllContentPagePaginationLimit');
};

export const setSharedWithMePagePaginationLimit = (num: number) => {
  return localStorage.setItem('SharedWithMePagePaginationLimit', `${num}`);
};
export const getSharedWithMePagePaginationLimit = () => {
  return localStorage.getItem('SharedWithMePagePaginationLimit');
};

export const setReflexComposersPagePaginationLimit = (num: number) => {
  return localStorage.setItem('ReflexComposersPagePaginationLimit', `${num}`);
};
export const getReflexComposersPagePaginationLimit = () => {
  return localStorage.getItem('ReflexComposersPagePaginationLimit');
};

export const setMyVideofeedsPagePaginationLimit = (num: number) => {
  return localStorage.setItem('MyVideofeedsPagePaginationLimit', `${num}`);
};
export const getMyVideofeedsPagePaginationLimit = () => {
  return localStorage.getItem('MyVideofeedsPagePaginationLimit');
};

export const getVideoQualityFromLocalStorage = () => {
  return localStorage.getItem('quality');
};
export const setVideoQualityToLocalStorage = (quality: string) => {
  return localStorage.setItem('quality', quality);
};

export const setSidebarVisibiltyToLocalStorage = (bool: string) => {
  return localStorage.setItem('showSidebar', bool);
};

export const getSidebarVisibilityFromLocalStorage = () => {
  return localStorage.getItem('showSidebar');
};

export type ComposerWebPreferences = {
  showVideoDrawingsWhenPlayingClips: boolean;
  muteAllVideos: boolean;
  sendClipsAddOnBottom: boolean;
  clipDefaultInSeconds: number;
  clipDefaultOutSeconds: number;
  playingArrowStepSeconds: number;
  shareAllowDownloadsDefault: boolean;
  shareAllowDownloadsDefaultOrganizationAdmin: boolean;
  shareAllowDownloadsDefaultAnalyst: boolean;
  shareAllowDownloadsDefaultViewer: boolean;
};

export const COMPOSER_WEB_PREFERENCES_EVENT = 'amplify:composer-web-preferences-updated';

const COMPOSER_WEB_PREFERENCES_KEY = 'ComposerWebPreferences';
const COMPOSER_WEB_PREFERENCES_DEFAULTS: ComposerWebPreferences = {
  showVideoDrawingsWhenPlayingClips: false,
  muteAllVideos: false,
  sendClipsAddOnBottom: true,
  clipDefaultInSeconds: 5,
  clipDefaultOutSeconds: 5,
  playingArrowStepSeconds: 5,
  shareAllowDownloadsDefault: false,
  shareAllowDownloadsDefaultOrganizationAdmin: false,
  shareAllowDownloadsDefaultAnalyst: false,
  shareAllowDownloadsDefaultViewer: false,
};

const normalizePreferenceNumber = (value: unknown, fallback: number) => {
  const num = Number(value);
  return Number.isFinite(num) && num >= 0 ? num : fallback;
};

const normalizePositivePreferenceNumber = (value: unknown, fallback: number) => {
  const num = Number(value);
  return Number.isFinite(num) && num > 0 ? num : fallback;
};

const normalizeComposerWebPreferences = (value: Partial<ComposerWebPreferences> = {}): ComposerWebPreferences => ({
  showVideoDrawingsWhenPlayingClips: value.showVideoDrawingsWhenPlayingClips === true,
  muteAllVideos:
    typeof value.muteAllVideos === 'boolean'
      ? value.muteAllVideos
      : COMPOSER_WEB_PREFERENCES_DEFAULTS.muteAllVideos,
  sendClipsAddOnBottom:
    typeof value.sendClipsAddOnBottom === 'boolean'
      ? value.sendClipsAddOnBottom
      : COMPOSER_WEB_PREFERENCES_DEFAULTS.sendClipsAddOnBottom,
  clipDefaultInSeconds: normalizePreferenceNumber(
    value.clipDefaultInSeconds,
    COMPOSER_WEB_PREFERENCES_DEFAULTS.clipDefaultInSeconds,
  ),
  clipDefaultOutSeconds: normalizePreferenceNumber(
    value.clipDefaultOutSeconds,
    COMPOSER_WEB_PREFERENCES_DEFAULTS.clipDefaultOutSeconds,
  ),
  playingArrowStepSeconds: normalizePositivePreferenceNumber(
    value.playingArrowStepSeconds,
    COMPOSER_WEB_PREFERENCES_DEFAULTS.playingArrowStepSeconds,
  ),
  shareAllowDownloadsDefault:
    typeof value.shareAllowDownloadsDefault === 'boolean'
      ? value.shareAllowDownloadsDefault
      : COMPOSER_WEB_PREFERENCES_DEFAULTS.shareAllowDownloadsDefault,
  shareAllowDownloadsDefaultOrganizationAdmin:
    typeof value.shareAllowDownloadsDefaultOrganizationAdmin === 'boolean'
      ? value.shareAllowDownloadsDefaultOrganizationAdmin
      : COMPOSER_WEB_PREFERENCES_DEFAULTS.shareAllowDownloadsDefaultOrganizationAdmin,
  shareAllowDownloadsDefaultAnalyst:
    typeof value.shareAllowDownloadsDefaultAnalyst === 'boolean'
      ? value.shareAllowDownloadsDefaultAnalyst
      : COMPOSER_WEB_PREFERENCES_DEFAULTS.shareAllowDownloadsDefaultAnalyst,
  shareAllowDownloadsDefaultViewer:
    typeof value.shareAllowDownloadsDefaultViewer === 'boolean'
      ? value.shareAllowDownloadsDefaultViewer
      : COMPOSER_WEB_PREFERENCES_DEFAULTS.shareAllowDownloadsDefaultViewer,
});

export const getComposerWebPreferences = (): ComposerWebPreferences => {
  try {
    const raw = localStorage.getItem(COMPOSER_WEB_PREFERENCES_KEY);
    return normalizeComposerWebPreferences(raw ? JSON.parse(raw) : {});
  } catch {
    return { ...COMPOSER_WEB_PREFERENCES_DEFAULTS };
  }
};

export const getDefaultShareAllowDownloads = (roleTitle?: string | null) => {
  const role = String(roleTitle || '')
    .toLowerCase()
    .replace(/[\s_-]+/g, '');
  const preferences = getComposerWebPreferences();

  if (role === 'organizationadmin' || role === 'superadmin') {
    return preferences.shareAllowDownloadsDefaultOrganizationAdmin;
  }
  if (role === 'analyst') {
    return preferences.shareAllowDownloadsDefaultAnalyst;
  }
  if (role === 'viewer') {
    return preferences.shareAllowDownloadsDefaultViewer;
  }
  return preferences.shareAllowDownloadsDefault;
};

export const setComposerWebPreferences = (preferences: Partial<ComposerWebPreferences>) => {
  const nextPreferences = normalizeComposerWebPreferences({
    ...getComposerWebPreferences(),
    ...preferences,
  });

  localStorage.setItem(
    COMPOSER_WEB_PREFERENCES_KEY,
    JSON.stringify(nextPreferences),
  );

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(COMPOSER_WEB_PREFERENCES_EVENT, {
        detail: nextPreferences,
      }),
    );
  }

  return nextPreferences;
};

export const subscribeComposerWebPreferences = (
  callback: (preferences: ComposerWebPreferences) => void,
) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const onPreferencesChange = (event: Event) => {
    callback(
      (event as CustomEvent<ComposerWebPreferences>).detail ||
        getComposerWebPreferences(),
    );
  };
  const onStorageChange = (event: StorageEvent) => {
    if (event.key === COMPOSER_WEB_PREFERENCES_KEY) {
      callback(getComposerWebPreferences());
    }
  };

  window.addEventListener(COMPOSER_WEB_PREFERENCES_EVENT, onPreferencesChange);
  window.addEventListener('storage', onStorageChange);

  return () => {
    window.removeEventListener(
      COMPOSER_WEB_PREFERENCES_EVENT,
      onPreferencesChange,
    );
    window.removeEventListener('storage', onStorageChange);
  };
};
